import type { ModalType } from '@/stores/ui-store';

export function pickUiSearch(search: Record<string, unknown>): {
  modal?: ModalType;
} {
  const modal = typeof search.modal === 'string' ? (search.modal as ModalType) : undefined;
  const result: { modal?: ModalType } = {};
  if (modal) result.modal = modal;
  return result;
}
